import { createFileRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { AUTH_ROUTES } from "@/components/layout/nav-config";

export const Route = createFileRoute("/account")({
  head: () => ({
    meta: [
      { title: "My Account — CB16" },
      { name: "description", content: "Manage your CB16 profile, orders, addresses and wishlist." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "My Account — CB16" },
      {
        property: "og:description",
        content: "Manage your CB16 profile, orders, addresses and wishlist.",
      },
    ],
  }),
  component: AccountLayout,
});

function AccountLayout() {
  const { isAuthenticated, ready } = useAuth();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (ready && !isAuthenticated && !AUTH_ROUTES.has(pathname)) {
      navigate({
        to: "/login",
        search: { redirect: pathname },
        replace: true,
      });
    }
  }, [ready, isAuthenticated, pathname, navigate]);

  if (!ready) {
    return (
      <div className="mx-auto max-w-7xl px-6 py-24 text-center">
        <div className="mx-auto h-6 w-6 animate-spin rounded-full border-2 border-black/10 border-t-[#C6A15B]" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return (
      <div className="mx-auto max-w-md px-6 py-24 text-center">
        <p className="text-sm text-black/60">Redirecting to sign in…</p>
      </div>
    );
  }
  return <Outlet />;
}
